import { tokens } from "../../../public/tokens.js";

/**
 * Returns the display label and styling for a module status chip used on module tiles.
 * @param {string} status - Current module status.
 * @param {boolean} passed - Whether the module was passed.
 * @param {string} grade - The module grade.
 */
export const buildStatusChip = (status, passed, grade, showResults) => {
    switch (status) {
        case "In Progress":
            return {
                label: "In Progress",
                style: {
                    backgroundColor: tokens.colors.states.info.default,
                },
            };
        case "Not Yet Published":
            return {
                label: "Upcoming",
                style: {
                    backgroundColor: tokens.colors.neutral["grey"]["500"],
                },
            };
        case "Not Started":
            return {
                label: "Not Started",
                style: {
                    backgroundColor: tokens.colors.brand["karoo-gold"]["500"],
                },
            };
        case "Finished":
            if (showResults === 0) {
                return {
                    label: "Completed",
                    style: {
                        backgroundColor: tokens.colors.states.success["500"],
                    },
                };
            }
            switch (passed) {
                case "PASS":
                    return {
                        label: grade,
                        icon: "fa fa-circle-check",
                        fontColor: tokens.colors.states["success"]["900"],
                        style: {
                            backgroundColor: tokens.colors.brand["fresh-green"]["100"],
                        },
                    };
                case "CONDONED":
                    return {
                        label: grade,
                        icon: "fa fa-circle-check",
                        fontColor: tokens.colors.brand["veld-sprout"]["900"],
                        style: {
                            backgroundColor: tokens.colors.brand["veld-sprout"]["200"],
                        },
                    };
                case "FAIL":
                    return {
                        label: grade,
                        icon: "fa fa-circle-x",
                        fontColor: tokens.colors.brand["red"]["900"],
                        style: {
                            backgroundColor: tokens.colors.brand["red"]["100"],
                        },
                    };
                case "witheld":
                    return {
                        label: "Result Withheld",
                        style: {
                            backgroundColor: tokens.colors.brand["burnt-orange"]["500"],
                        },
                    };
                default:
                    return {
                        label: "Completed",
                        style: {backgroundColor: tokens.colors.states["success"]["500"],},
                    };
            }
        default:
            return "";
    };
}

/**
 * Returns the color configuration for a module tile background based on status.
 * @param {string} status - Current module status.
 * @param {boolean} passed - Whether the module was passed.
 */
export const headerColor = (status, passed) => {
    switch (status) {
        case "In Progress":
            return {
                backgroundColor: tokens.colors.brand["tide-blue"]["900"],
            };
        case "Not Yet Published":
            return {
                color: tokens.colors.text.primary,
                backgroundColor: tokens.colors.brand["aie-blue"]["100"],
            };
        case "Not Started":
            return {
                backgroundColor: tokens.colors.neutral["grey"]["700"],
            };
        case "Finished": {
            let backgroundColor;

            switch (passed) {
                case "PASS":
                    backgroundColor = tokens.colors.states["success"]["900"];
                    break;

                case "FAIL":
                    backgroundColor = tokens.colors.states["alert"]["900"];
                    break;

                case "witheld":
                    backgroundColor = tokens.colors.brand["burnt-orange"]["800"];
                    break;

                default:
                    backgroundColor = tokens.colors.states["success"]["900"];
                    break;
            }

            return {
                backgroundColor,
            };
        }
        default:
            return "";
    }
};

/**
 * Converts a learning method code into a user-friendly label.
 * @param {string} data - Learning method value from the API.
 * @returns {string} Formatted learning method text.
 */
export const GetLearningMethodText = (data) => {
    switch (
    data
        ? data.toString().replace("-", "").replace(" ", "").toLowerCase()
        : ""
    ) {
        case "full":
        case "fulltimecontact":
        case "full_time_hybrid":
            return "Full Time, Hybrid";
        case "fulltimeonline":
        case "full_time_online":
        case "online":
            case "fulltime, online":
            return "Full Time, Online";
        case "part":
        case "parttime":
        case "parttimeonline":
        case "part_time_online":
        case "cores":
        case "correspondence":
        case "part time":
            return "Part-Time, Online";
        case "selfplaced":
        case "selfpaced":
            return "Self-Paced";
        default:
            return "-";
    }
};

export const GetCampusText = (data) => {
    switch (
        data
            ? data.toString().replace("-", "").toLowerCase()
            : ""
    ) {
        case "capetown":
        case "cape town":
            return "Cape Town";
        case "centpre":
            return "Centurion, Pretoria";
        case "correspondence":
            return "Correspondence";
        case "gdc":
        case "greenside campus":
        case "greenside":
            return "Greenside";
        case "pretoria":
            return "Pretoria";
        case "midjohn":
        case "midrand":
        case "midrand campus":
            return "Midrand";
        case "cape campus":
            return "Cape";
        case "online":
            return "Online";
        case "hatfield":
            return "Hatfield";
        case "on site":
            return "Hatfield";
        default:
            return "-";
    }
};

